import { ensureString } from '@app/lib/util/ensureString';
import { HOME_INSURANCE_STEPS } from '@app/app/esales/home/_sections/steps/HOME_INSURANCE_STEPS';
import { PurchaseHomeInsuranceSteps } from '@app/service/eshop/home/schemas/PurchaseHomeInsuranceSteps';
import { Schema } from 'yup';

export interface StepValidationData {
    schema: Schema;
    data: Record<string, unknown>;
    loaderTextKey: string;
}

export function buildStepValidationData(stepKey: string, formData: FormData): Nullable<StepValidationData> {
    switch (stepKey) {
        case HOME_INSURANCE_STEPS.OBJECT_SUMMARY_EDITABLE:
            return {
                schema: PurchaseHomeInsuranceSteps[HOME_INSURANCE_STEPS.OBJECT_SUMMARY_EDITABLE],
                data: {
                    objectType: ensureString(formData.get('objectType'), ''),
                    constructionType: ensureString(formData.get('constructionType'), ''),
                    totalArea:
                        ensureString(formData.get('totalArea'), '') !== ''
                            ? parseFloat(ensureString(formData.get('totalArea'), ''))
                            : 0,
                    constructionYear:
                        ensureString(formData.get('constructionYear'), '') !== ''
                            ? parseInt(ensureString(formData.get('constructionYear'), ''), 10)
                            : 0,
                    pledgedToBank: ensureString(formData.get('pledgedToBank'), ''),
                    leasing: ensureString(formData.get('leasing'), ''),
                    leasingName: ensureString(formData.get('leasingName'), ''),
                },
                loaderTextKey: 'eshop.home.calculatingPremiums',
            };

        case HOME_INSURANCE_STEPS.OBJECT_SUMMARY_READ_ONLY:
            return {
                schema: PurchaseHomeInsuranceSteps[HOME_INSURANCE_STEPS.OBJECT_SUMMARY_READ_ONLY],
                data: {
                    pledgedToBank: ensureString(formData.get('pledgedToBank'), ''),
                    leasing: ensureString(formData.get('leasing'), ''),
                    leasingName: ensureString(formData.get('leasingName'), ''),
                },
                loaderTextKey: 'eshop.home.calculatingPremiums',
            };

        case HOME_INSURANCE_STEPS.SUMMARY:
            return {
                schema: PurchaseHomeInsuranceSteps[HOME_INSURANCE_STEPS.SUMMARY],
                data: {
                    uniqueNumber: ensureString(formData.get('uniqueNumber'), ''),
                    acceptToPrivacyPolicy: formData.get('acceptToPrivacyPolicy') === 'true',
                    acceptToHomeRules: formData.get('acceptToHomeRules') === 'true',
                    acceptToMarketingCnl: formData.get('acceptToMarketingCnl') === 'true',
                    acceptToMarketingCl: formData.get('acceptToMarketingCl') === 'true',
                    pledgedToBank: ensureString(formData.get('pledgedToBank'), ''),
                    leasing: ensureString(formData.get('leasing'), ''),
                    leasingName: ensureString(formData.get('leasingName'), ''),
                },
                loaderTextKey: 'eshop.home.preparingOffer',
            };

        default:
            return null;
    }
}
